import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Card, CardHeader, useTheme } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import styles from './incidentDisplayCard.module.scss';
import { AccountTypes } from '../changeUser/accountTypes.enum';
import { getRouteByAccountType } from '../../routes/getRouteByAccountType';
import { di } from '../../state/inversify.config';
import { CreateIncidentDomainService } from '../../pages/createIncident/createIncidentDomainService';

interface IncidentDisplayCardProps {
  accountType: AccountTypes | undefined;
}

export const IncidentDisplayCard = ({
  accountType,
}: IncidentDisplayCardProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const theme = useTheme();

  const incidentDomainService = di.get<CreateIncidentDomainService>(
    CreateIncidentDomainService,
  );

  const reportIncident = () => {
    if (accountType) {
      navigate(`/${getRouteByAccountType(accountType)}/create-incident`);
    }
    incidentDomainService.dispatchSetSelectedPlayerToEmpty();
    incidentDomainService.dispatchResetStep();
  };

  return (
    <Card
      onClick={reportIncident}
      sx={{
        background: theme.palette.primary.main,
        borderRadius: 4,
        maxWidth: 550,
        mt: 2,
        mb: 2,
      }}
    >
      <CardHeader
        data-testid="incidentCard"
        title={t('SOMEONE_TAKE_A_HIT')}
        subheader={t('SUSPECTED_CONCUSSION')}
        action={
          <div className={styles.cardActionContainer}>
            <AddCircleIcon
              sx={{ fill: theme.palette.secondary.main }}
              fontSize="large"
            />
          </div>
        }
        titleTypographyProps={{
          variant: 'h6',
          color: theme.palette.text.secondary,
          fontWeight: 'bold',
        }}
        subheaderTypographyProps={{
          variant: 'subtitle1',
          color: theme.palette.text.secondary,
        }}
        sx={{
          '&:hover': {
            cursor: 'pointer',
          },
        }}
      />
    </Card>
  );
};
